// Utilities
import axios from 'axios';
import { VDatePickerYears } from 'vuetify/lib';

const state = {
  drawer: true,
  home: [
    {
      icon: 'mdi-image',
      text: 'Carousel',
      to: '/Carousel',
    },
    {
      icon: 'mdi-lightbulb',
      text: 'Projets',
      to: '/Projets',
    },
    // {
    //   icon: 'mdi-key',
    //   text: 'Lots à vendre',
    //   to: '/Lots',
    // },
  ],
  appels: [
    {
      icon: 'mdi-briefcase',
      text: "Gestion d'appels d'offres",
      to: "/Gestion-d'appel-d'offres",
    },
  ],
  lots: [
    {
      icon: 'mdi-key-variant',
      text: 'Gestion lots à vendre',
      to: '/Gestion-lots-a-vendre',
    },
  ],
  carriere: [
    {
      icon: 'mdi-offer',
      text: "Offres d'emploi",
      to: "/Gestion-offres-d'emploi",
    },
  ],
  projets: [
    {
      icon: 'mdi-office-building',
      text: 'Gestion Iskane',
      to: '/Gestion-iskane',
    },
    {
      icon: 'mdi-file-check',
      text: 'Gestion Equipements',
      to: '/Gestion-equipements',
    },
    {
      icon: 'mdi-file-check',
      text: 'Gestion accompagnement social',
      to: '/Gestion-accompagnement-social',
    },
  ],
  medias: [
    {
      icon: 'mdi-microphone-variant',
      text: 'Gestion Communiqués de presse',
      to: '/Gestion-communiques-de-presse',
    },
    {
      icon: 'mdi-video',
      text: 'Gestion Videotheque',
      to: '/Gestion-videotheque',
    },
    {
      icon: 'mdi-typewriter',
      text: 'Gestion Publications',
      to: '/Gestion-publication',
    },
    {
      icon: 'mdi-tooltip-image',
      text: 'Gestion Photothéque',
      to: '/Gestion-phototéque',
    },
  ],
  toRender: true,
  test: 'test',
  seller_object: {},
  chef_object: {},
  card_object: {},
  margin: null,
};

const mutations = {
  SET_SELLER_OBJECTS(state, payload) {
    state.seller_object = payload;
  },
  SET_CHEF_OBJECTS(state, payload) {
    state.chef_object = payload;
  },
  SET_CARD_OBJECTS(state, payload) {
    state.card_object = payload;
  },
  SET_MARGIN(state, payload) {
    state.margin = payload;
  },
};

const actions = {
  Seller({ commit }, seller) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/api/DR4GPEQP27D12H06Z12D/sellersdata',
        method: 'GET',
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      })
        .then((resp) => {
          commit('SET_SELLER_OBJECTS', resp.data);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  Chef({ commit }, seller) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/api/DR4GPEQP27D12H06Z12D/chefsdata',
        method: 'GET',
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      })
        .then((resp) => {
          commit('SET_CHEF_OBJECTS', resp.data);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  Card({ commit }, seller) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/api/DR4GPEQP27D12H06Z12D/cardsdata',
        method: 'GET',
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      })
        .then((resp) => {
          commit('SET_CARD_OBJECTS', resp.data);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  Margin({ commit }, seller) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/api/DR4GPEQP27D12H06Z12D/margin',
        method: 'GET',
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      })
        .then((resp) => {
          commit('SET_MARGIN', resp.data);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
